import template from './land-gas.jade';
import items from '../../../enums/land-communications-location';
import itemsPressureType from '../../../enums/gas-pressure-type';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.aboutObjectLandGas', [])
    .directive('cianAfAboutObjectLandGas', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = items;
            this.itemsPressureType = itemsPressureType;
            this.ad.gas = this.ad.gas || {};

            const isOnTypes = ['border', 'location'];
            this.isOn = () => isOnTypes.includes(this.ad.gas.locationType);

            this.isOnPossibleConnect = () => this.ad.gas.locationType === 'no';

            this.maxCapacity = 1000;
            this.minCapacity = 0;

            this.validationCapacity = validation(this.form, 'gas.capacity', {
                parse: 'Введите число',
                max: 'Допустимо не более 3 символов',
                min: 'Введите число',
            });
        },
        controllerAs: 'landGas',
        template,
    }))
    .name;
